var map = {
	"./boxTypes/routes": "965e",
	"./dashboard/routes": "cfc7",
	"./inputMessages/routes": "021f",
	"./machines/routes": "698d",
	"./orders/routes": "3c2a",
	"./packageReturns/routes": "adf2",
	"./pressSheets/routes": "d87f",
	"./products/routes": "7b2e",
	"./settings/routes": "5943",
	"./substrates/routes": "9e88b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef37";